import sha256 from 'crypto-js/sha256';

const { routes: lcw } = require('../data/lcw')

function getUrl(host, path=false)
{
    let lcwpath = getLcwPath(path)
    if (path && lcwpath)
    {
        let ywplcw = [lcw.sbs, lcw.sways, lcw.tvc, lcw.vfl, lcw.wyd, lcw.ds]
        let yfplcw = [lcw.eo, lcw.ob]
        
        if (host.includes("localhost"))
        {
            if (ywplcw.includes(lcwpath))
                return "//demo.wellness.myonlinehubsite.local" + path
            else if (yfplcw.includes(lcwpath))
                return "//demo.business.myonlinehubsite.local" + path
        }

        if (host.includes("wellness.") || host.includes("business."))
            return host + lcwpath
    }

    if (host.includes("localhost"))
        return "//demo.myonlinehubsite.local"

    if (host.includes("business.") || host.includes("wellness."))
        return host

    return host + (path ? path : "")
}

function errorResponse(error)
{
    var response = {}
    if (error.response && error.response.errors)
    {
        var response = error.response.errors[0]
        if (![400, 403, 404].includes(response.code))
            response.code = 500
        return response
    }
    response = { code: 503, message: error.message }
    return response
}

function getLcwPath(path)
{
    if (path)
    {
        for (let key in lcw) 
        {
            if (path.includes(lcw[key]))
                return lcw[key]
        }
    }
    return false
}

function formatSiteUrls(sites)
{
    var formatted = [];
    for (var i = 0 ; i < sites.length ; i++)
    {
        formatted.push({
            name: sites[i].site.name,
            code: sites[i].site.code,
            subdomainUrl: sites[i].subdomainUrl,
            domainUrl: sites[i].domainUrl
        })
    }
    return formatted
}

function findSiteByCode(sites, code)
{
    for (var i=0; i<sites.length; i++)
    {
        var site = sites[i]
        if (site.site && site.site.code && site.site.code == code)
            return site
    }

    return false
}

function isDomain(domain) 
{
    if (typeof domain !== 'string') return false;

    // Remove query string if present
    domain = domain.split('?')[0];

    // Ensure domain doesn't start with protocol (http://, https://)
    domain = domain.replace(/^(https?:\/\/)/, '');

    // Remove everything after the first slash (including the slash)
    domain = domain.split('/')[0];

    // Regular expression to validate domain format
    const domainRegex = /^([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}$/;
    if (!domainRegex.test(domain)) return false;

    // Split by dot and check if there are exactly two parts (root domain + TLD)
    const parts = domain.split('.');
    return parts.length === 2;
}


function canCustomize(query, id)
{
    if (query.customize && query.t)
    {
        let digest = sha256(id + ":" + query.t)
        if ((new Date(query.t * 1000).getTime() + 86400000) > new Date().getTime())
        {
            if (query.customize == digest)
                return true
        }
    }

    return false
}

/**
 * Method to parse data from {new FormData(<HTMLFormElement>)} object to a
 * more readable value suitable for POST api request
 */
function parseFormData(formDataObject)
{
    let parsedFormData = {}
    for (let [name, value] of formDataObject) {
        parsedFormData[name] = value
    }

    return parsedFormData
}

function stripTags(html)
{
    return html.replace(/(<([^>]+)>)/gi, "")
}

function insertAt(array, index, ...elementsArray) 
{    
    return array.splice(index, 0, ...elementsArray);
}

function getColumn(arr, key)
{
    var newarr = []
    for (var i=0; i < arr.length; i++)
    {
        newarr.push(arr[i][key])
    }
    return newarr
}

function findByKey(haystack, needle, key)
{
    for (var i=0; i < haystack.length; i++)
    {
        if (haystack[i][key] == needle)
            return haystack[i]
    }
    return false
}

module.exports = {
    getUrl: getUrl,
    errorResponse: errorResponse,
    getLcwPath: getLcwPath,
    formatSiteUrls: formatSiteUrls,
    findSiteByCode: findSiteByCode,
    canCustomize: canCustomize,
    parseFormData: parseFormData,
    stripTags: stripTags,
    insertAt: insertAt,
    getColumn: getColumn,
    findByKey: findByKey,
    isDomain: isDomain
}
